import { render } from "./StudentDashboard.vue?vue&type=template&id=06a8ff59&scoped=true"
import script from "./StudentDashboard.vue?vue&type=script&lang=js"
export * from "./StudentDashboard.vue?vue&type=script&lang=js"

import "./StudentDashboard.vue?vue&type=style&index=0&id=06a8ff59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a8ff59"]])

export default __exports__